import {
    GET_BILLS_REQUEST, GET_BILLS_SUCCESS, GET_BILLS_FAIL,
    CREATE_BILL_REQUEST, CREATE_BILL_SUCCESS, CREATE_BILL_FAIL,
    UPDATE_BILL_REQUEST, UPDATE_BILL_SUCCESS, UPDATE_BILL_FAIL,
    DELETE_BILL_REQUEST, DELETE_BILL_SUCCESS, DELETE_BILL_FAIL
} from "../types/billTypes";

function deleteBillReducer(state = { deleteBill: {} }, action) {
    switch (action.type) {
        case DELETE_BILL_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case DELETE_BILL_SUCCESS:
            return {
                ...state,
                deleteBill: action.payload,
                isLoading: false
            }
        case DELETE_BILL_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function updateBillReducer(state = { updateBill: {} }, action) {
    switch (action.type) {
        case UPDATE_BILL_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_BILL_SUCCESS:
            return {
                ...state,
                updateBill: action.payload,
                isLoading: false
            }
        case UPDATE_BILL_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function createBillReducer(state = { createBill: {} }, action) {
    switch (action.type) {
        case CREATE_BILL_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_BILL_SUCCESS:
            return {
                ...state,
                createBill: action.payload,
                isLoading: false
            }
        case CREATE_BILL_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getBillsReducer(state = { bills: [] }, action) {
    switch (action.type) {
        case GET_BILLS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_BILLS_SUCCESS:
            return {
                ...state,
                bills: action.payload,
                isLoading: false
            }
        case GET_BILLS_FAIL:
            return {
                ...state,
                error: action.payload,
                bills: [],
                isLoading: false
            }
        default:
            return state;
    }
}

function getVendorBillsReducer(state = { bills: [] }, action) {
    switch (action.type) {
        case GET_BILLS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_BILLS_SUCCESS:
            return {
                ...state,
                bills: action.payload,
                isLoading: false
            }
        case GET_BILLS_FAIL:
            return {
                ...state,
                error: action.payload,
                bills: [],
                isLoading: false
            }
        default:
            return state;
    }
}

export { getBillsReducer, getVendorBillsReducer, createBillReducer, updateBillReducer, deleteBillReducer }